import Inside from "./FocusInside"
import FocusTrap from "./FocusTrap"

export { default as FocusManager } from "./FocusManager"
export default Object.assign(FocusTrap, { Inside })
